var map = {
  "./BCOM/index.ts": [
    "15322",
    "src_plugins_Partners_BCOM_index_ts"
  ],
  "./JJK/index.ts": [
    "26062",
    "src_plugins_Partners_JJK_index_ts"
  ],
  "./GEB/index.ts": [
    "77910",
    "src_plugins_Partners_GEB_index_ts"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45472;
module.exports = webpackAsyncContext;
